import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AgentSchema = withDefaults({
  type: 'agent',
  objectExtensions: ['agent'],
  fields: [
    {
      kind: 'attribute',
      name: 'firstName',
    },
    {
      kind: 'attribute',
      name: 'lastName',
    },
    {
      kind: 'attribute',
      name: 'email',
    },
    {
      kind: 'attribute',
      name: 'customAttributes',
    },
    {
      kind: 'belongsTo',
      name: 'workspace',
      type: 'workspace',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'workspaces',
      type: 'workspace',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default AgentSchema;
